import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null
  },
  mutations: {
    login_success(state, user) {
      state.user = user
    },
    logout_success(state) {
      state.user = null
    }
  },
  actions: {
    async login({ commit }, credentials) {
      const { data } = await this._vm.$http.post("/auth/", credentials)

      localStorage.setItem("user", JSON.stringify(data))
      commit("login_success", data)
    },
    async logout({ commit }) {
      await this._vm.$http.delete("/auth/")

      localStorage.setItem("user", null)
      commit("logout_success")
    }
  },
  getters: {
    isLoggedIn(state) {
      return state.user !== null
    },
  },
  modules: {
  }
})
